import React, { useState } from "react";
import "./SelfIntroduce.css";

function SelfIntroduce() {
  const [name, setName] = useState("");
  const [bio, setBio] = useState("");
  const [interests, setInterests] = useState([]);
  const [darkMode, setDarkMode] = useState(false);
  const [photo, setPhoto] = useState(null);
  const [age, setAge] = useState("");
  const [location, setLocation] = useState("");
  const [skills, setSkills] = useState("");

  const interestList = ["Reading", "Coding", "Music", "Travel", "Art"];

  const handleInterestChange = (e) => {
    const selected = e.target.value;
    setInterests((prev) =>
      prev.includes(selected)
        ? prev.filter((i) => i !== selected)
        : [...prev, selected]
    );
  };

  const handlePhotoUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onloadend = () => setPhoto(reader.result);
    if (file) reader.readAsDataURL(file);
  };

  return (
    <div className={`container ${darkMode ? "dark" : "light"}`}>
      <h2>🗣️ Introduce Yourself</h2>

      <label>Name:</label>
      <input type="text" value={name} onChange={(e) => setName(e.target.value)} />

      <label>Age:</label>
      <input type="text" value={age} onChange={(e) => setAge(e.target.value)} />

      <label>Location:</label>
      <input type="text" value={location} onChange={(e) => setLocation(e.target.value)} />

      <label>Skills:</label>
      <input type="text" value={skills} onChange={(e) => setSkills(e.target.value)} />

      <label>About You:</label>
      <textarea value={bio} onChange={(e) => setBio(e.target.value)} />

      <label>Upload Photo:</label>
      <input type="file" accept="image/*" onChange={handlePhotoUpload} />

      <label>Interests:</label>
      <div className="interests">
        {interestList.map((interest) => (
          <label key={interest}>
            <input
              type="checkbox"
              value={interest}
              checked={interests.includes(interest)}
              onChange={handleInterestChange}
            />
            {interest}
          </label>
        ))}
      </div>

      <label>
        <input
          type="checkbox"
          checked={darkMode}
          onChange={() => setDarkMode(!darkMode)}
        />
        Dark Mode
      </label>

      <div className="profile-card">
        <h3>👤 Your Profile</h3>
        {photo && <img src={photo} alt="Photo" className="card-photo" />}
        <p><strong>Name:</strong> {name}</p>
        <p><strong>Age:</strong> {age}</p>
        <p><strong>Location:</strong> {location}</p>
        <p><strong>Skills:</strong> {skills}</p>
        <p><strong>Bio:</strong> {bio}</p>
        <p><strong>Interests:</strong> {interests.join(", ") || "None selected"}</p>
      </div>
    </div>
  );
}

export default SelfIntroduce;
